<template>
    <div>
        <div class="top-section">
            <!-- 店铺信息区域 -->
            <div class="shop-info-section">
                <div class="shop-avatar">
                    <img :src="shopInfo.store_logo" alt="店铺头像">
                </div>
                <div class="shop-details">
                    <div class="shop-name">{{ shopInfo.store_name }}</div>
                    <div style="display: flex; align-items: center; justify-content: center;">
                        <div class="stars">
                            <i class="el-icon-star-on" v-for="n in 5" :key="n"
                                :style="{ color: n <= shopInfo.store_star ? '#F7BA2A' : '#E0E0E0' }"></i>
                        </div>
                        <div class="shop-followers">{{ shopInfo.merchant_follow_num }}人关注</div>
                    </div>

                </div>
                <div class="editBtn" @click="goRenzheng">
                    <span>入驻信息</span>
                </div>
            </div>
            <!-- 店铺订单区域 -->
            <div class="order-section">
                <div class="section-title">店铺订单</div>
                <div class="order-stats">
                    <div class="stat-item">
                        <div class="stat-number">{{ order_num.no_pay }}</div>
                        <div class="stat-label">待支付</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">{{ order_num.deliver }}</div>
                        <div class="stat-label">待发货</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">{{ order_num.receiv }}</div>
                        <div class="stat-label">待收货</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">{{ order_num.finish }}</div>
                        <div class="stat-label">已完成</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">{{ order_num.refund }}</div>
                        <div class="stat-label">售后中</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 数据概览区域 -->
        <div class="data-overview-section">
            <div class="headerLeft">
                <span class="line"></span>
                <span class="title">数据概览</span>
                <div class="tab-switcher">
                    <span v-for="tab in tabs" :key="tab.value"
                        :class="['tab-item', { active: activeTab === tab.value }]" @click="switchTab(tab.value)">
                        {{ tab.label }}
                    </span>
                </div>
            </div>
            <div class="data-cards">
                <div class="data-card">
                    <img src="~@/assets/images/72.png" alt="订单图标" class="data-icon">
                    <div class="data-info">
                        <div class="data-value">{{ dayData.order_num }}</div>
                        <div class="data-label">订单数（笔）</div>
                    </div>
                </div>
                <div class="data-card">
                    <img src="~@/assets/images/73.png" alt="订单图标" class="data-icon">
                    <div class="data-info">
                        <div class="data-value">{{ dayData.total_money }}</div>
                        <div class="data-label">订单总额（元）</div>
                    </div>
                </div>
                <div class="data-card">
                    <img src="~@/assets/images/74.png" alt="订单图标" class="data-icon">
                    <div class="data-info">
                        <div class="data-value">{{ dayData.merchant_follow_num }}</div>
                        <div class="data-label">店铺关注数</div>
                    </div>
                </div>
            </div>
            <div class="data-echarts">
                <div class="echarts-box">
                    <div class="date-box">
                        <span class="date-title">销售额（元）</span>
                        <span class="title-value">{{ salesData.total_amount }}</span>
                        <div class="date-selector">
                            <el-select v-model="date_value" placeholder="请选择时间范围" @change="handleSalesDateChange">
                                <el-option :value="date.value" v-for="date in date_arr" :key="date.value"
                                    :label="date.name"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div id="salesChart" style="width: 100%; height: 300px;"></div>
                </div>
                <div class="echarts-box">
                    <div class="date-box">
                        <span class="date-title">订单数（笔）</span>
                        <span class="title-value">{{ ordersData.total_amount }}</span>
                        <div class="date-selector">
                            <el-select v-model="order_value" placeholder="请选择时间范围" @change="handleOrdersDateChange">
                                <el-option :value="date.value" v-for="date in date_arr" :key="date.value"
                                    :label="date.name"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div id="ordersChart" style="width: 100%; height: 300px;"></div>
                </div>
            </div>
        </div>
        <!-- 报价弹窗 -->
        <el-dialog title="商品报价" :visible.sync="dialogVisible" width="60%" center>
            <el-table :data="tableData" style="width: 100%" border :row-class-name="getRowClass">
                <el-table-column label="商品图片">
                    <template slot-scope="scope">
                        <img :src="scope.row.thumb" style="width: 50px; height: 50px;">
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"></el-table-column>
                <el-table-column label="参考价">
                    <template slot-scope="scope">
                        ￥{{ scope.row.refer_price }}/{{ scope.row.unit }}
                    </template>
                </el-table-column>
                <el-table-column label="单价">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center;">
                            ￥<el-input v-model="scope.row.price" placeholder="请输入报价" style="flex: 1;"></el-input>/{{
                            scope.row.unit }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitPrice">提交报价</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'ShopDashboard',
    data() {
        return {
            dialogVisible: false, // 报价弹窗是否可见
            tableData: [], // 报价商品列表数据
            shopInfo: {
                store_logo: '',
                store_name: '',
                store_star: 0,
                merchant_follow_num: 0
            },
            order_num: {
                deliver: 0,
                evaluate: 0,
                no_pay: 0,
                receiv: 0,
                refund: 0,
            },
            // 标签页数据
            tabs: [
                { label: '今日', value: '1' },
                { label: '昨日', value: '2' },
                { label: '总计', value: '3' }
            ],
            activeTab: '1', // 默认选中今日
            date_arr: [{
                name: '7天',
                value: '7',
            }, {
                name: '15天',
                value: '15',
            }, {
                name: '30天',
                value: '30',
            }],
            date_value: '7',
            order_value: '7',
            // 数据概览区域数据
            dayData: {
                merchant_follow_num: 0,
                order_num: 0,
                total_money: 0
            },
            // 图表实例
            salesChart: null,
            ordersChart: null,
            // 图表数据
            salesData: {
                date: [],
                sales: [],
                total_amount: 0
            },
            ordersData: {
                date: [],
                sales: [],
                total_amount: 0
            }

        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    mounted() {
        this.getShopInfo();
        this.getIsPurchase();
        this.getShopOrderNum();
        this.getDayData();
        // 初始化图表
        this.$nextTick(() => {
            this.initCharts();
            this.getShopSales();
            this.getShopOrderData();
        });
    },
    beforeDestroy() {
        // 销毁图表实例，避免内存泄漏
        if (this.salesChart) {
            this.salesChart.dispose();
        }
        if (this.ordersChart) {
            this.ordersChart.dispose();
        }
    },
    methods: {
        // 提交今日报价
        submitPrice() {
            let is_empty = this.tableData.some(item => item.price == '' || item.price <= 0);
            if (is_empty) return this.$message.info('请填写完整，金额不可小于零');
            let arr = this.tableData.map(item => {
                return {
                    goods_id: item.aid,
                    price: item.price,
                }
            })
            this.$api.todayQuotation({
                goods_info: JSON.stringify(arr)
            }).then(res => {
                this.$message.success('提交成功');
                this.dialogVisible = false;
            }).catch(err => {
                this.$message.error(err.msg);
            })
        },
        // 根据ratio值计算背景颜色
        getRowClass(row) {
            if (String(row.ratio) > '0.1') {
                return 'row-high';
            } else if (String(row.ratio) < '0.1') {
                return 'row-low';
            } else {
                return 'row-normal';
            }
        },
        // 获取是否能报价
        getIsPurchase() {
            this.$api.dayPurchase().then(res => {

            }).catch(err => {
                this.getPurchaseGoods();
            })
        },
        // 获取商品列表
        getPurchaseGoods() {
            this.$api.purchaseGoods().then(res => {
                this.tableData = res;
                this.dialogVisible = true;
            }).catch(err => {
                this.$message.error(err.msg);
            })
        },
        // 处理销售额日期选择变化
        handleSalesDateChange() {
            this.getShopSales();
        },
        // 处理订单数日期选择变化
        handleOrdersDateChange() {
            this.getShopOrderData();
        },
        // 初始化图表
        initCharts() {
            // 初始化销售额图表
            this.salesChart = echarts.init(document.getElementById('salesChart'));
            // 初始化订单数图表
            this.ordersChart = echarts.init(document.getElementById('ordersChart'));
            // 设置图表的基础配置
            this.updateSalesChart();
            this.updateOrdersChart();
            // 监听窗口大小变化，调整图表大小
            window.addEventListener('resize', () => {
                if (this.salesChart) this.salesChart.resize();
                if (this.ordersChart) this.ordersChart.resize();
            });
        },
        // 更新销售额图表
        updateSalesChart() {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}: {c}元'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.salesData.date,
                    axisLine: {
                        lineStyle: {
                            color: '#E0E0E0'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#E0E0E0'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#F5F5F5'
                        }
                    }
                },
                series: [
                    {
                        name: '销售额',
                        type: 'line',
                        data: this.salesData.sales,
                        smooth: true,
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(37, 99, 229, 0.3)' },
                                { offset: 1, color: 'rgba(37, 99, 229, 0.05)' }
                            ])
                        },
                        lineStyle: {
                            color: '#2563E5',
                            width: 3
                        },
                        itemStyle: {
                            color: '#2563E5'
                        }
                    }
                ]
            };
            this.salesChart.setOption(option);
        },
        // 更新订单数图表
        updateOrdersChart() {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}: {c}'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.ordersData.date,
                    axisLine: {
                        lineStyle: {
                            color: '#E0E0E0'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#E0E0E0'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#F5F5F5'
                        }
                    }
                },
                series: [
                    {
                        name: '订单数',
                        type: 'line',
                        data: this.ordersData.sales,
                        smooth: true,
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(255, 153, 0, 0.3)' },
                                { offset: 1, color: 'rgba(255, 153, 0, 0.05)' }
                            ])
                        },
                        lineStyle: {
                            color: '#FF9900',
                            width: 3
                        },
                        itemStyle: {
                            color: '#FF9900'
                        }
                    }
                ]
            };
            this.ordersChart.setOption(option);
        },
        getShopOrderData() {
            this.$api.getShopOrderData({
                partner_id: this.userInfo.user_merchant_id,
                days: this.order_value
            }).then(res => {
                this.ordersData = res;
                this.updateOrdersChart();
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        getShopSales() {
            this.$api.getShopSales({
                partner_id: this.userInfo.user_merchant_id,
                days: this.date_value
            }).then(res => {
                this.salesData = res;
                this.updateSalesChart();
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        getShopInfo() {
            this.$api.getShopInfo({
                partner_id: this.userInfo.user_merchant_id
            }).then(res => {
                this.shopInfo = res;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        // 获取店铺订单数量
        getShopOrderNum() {
            this.$api.getShopOrderNum().then(res => {
                this.order_num = res;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        getDayData() {
            this.$api.getShopOrderStats({
                partner_id: this.userInfo.user_merchant_id,
                date: this.activeTab
            }).then(res => {
                this.dayData = res;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        goRenzheng() {
            this.$emit('goToComponent', 'ShopWaiting', { certified: '5' });
        },
        // 切换标签页
        switchTab(value) {
            if (this.activeTab != value) {
                this.activeTab = value;
                this.getDayData();
            }
        }
    }
}
</script>

<style scoped>
/* 顶部区域 - 店铺信息和订单统计同一行 */
.top-section {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 20px;
    margin-bottom: 20px;
}

/* 店铺信息区域 */
.shop-info-section {
    background: url('~@/assets/images/51.png') no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 240px;
    color: #ffffff;
    position: relative;
}

.shop-avatar {
    margin-bottom: 15px;
}

.shop-avatar img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.shop-details {
    margin-bottom: 20px;
}

.shop-name {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
}

.shop-followers {
    font-size: 14px;
    opacity: 0.9;
    margin-left: 10px;
}

/* 店铺订单区域 */
.order-section {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 24px;
    flex: 1;
    border: 1px solid #f0f0f0;
}

.section-title {
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 25px;
}

.order-stats {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.stat-number {
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 16px;
}

.stat-label {
    font-size: 14px;
    color: #666666;
}

/* 数据概览区域 */
.data-overview-section {
    margin-bottom: 20px;
}


.headerLeft {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 20px;
}

.line {
    display: block;
    width: 4px;
    height: 18px;
    background-color: #286CED;
    border-radius: 2px;
    margin-right: 12px;
}

/* 标签页样式 */
.tab-switcher {
    display: flex;
    background-color: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    margin-left: auto;
}

.tab-item {
    padding: 4px 12px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #666666;
}

.tab-item.active {
    background-color: #286CED;
    color: #ffffff;
}

.tab-item:hover {
    background-color: rgba(40, 108, 237, 0.1);
}

.tab-item.active:hover {
    background-color: #286CED;
}

.data-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}

.data-card {
    background: linear-gradient(to bottom, #E8EEFC, #FFF);
    border-radius: 8px;
    padding: 24px;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.data-icon {
    width: 56px;
    height: 56px;
    margin-right: 20px;
}

.data-info {
    flex: 1;
}

.data-value {
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 5px;
}

.data-label {
    font-size: 14px;
    color: #666666;
}

.editBtn {
    width: 80px;
    height: 32px;
    background: #47A01A;
    border-radius: 4px 4px 4px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 0px;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
}

.stars {
    display: flex;
    gap: 2px;
}

.stars i {
    font-size: 14px;
}

.data-echarts {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 32px;
}

.echarts-box {
    width: 49%;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 12px 0px;
}

.date-box {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 0px 24px;
}

.date-selector {
    width: 80px;
    margin-left: auto;
}

/* 报价弹窗表格行样式 */
::v-deep .el-table .row-high {
    background-color: #fef0f0 !important;
}

::v-deep .el-table .row-low {
    background-color: #fff7e6 !important;
}

::v-deep .el-table .row-normal {
    background-color: #fff !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-section {
        flex-direction: column;
    }

    .order-stats {
        flex-wrap: wrap;
    }

    .stat-item {
        flex: 1 1 50%;
        margin-bottom: 15px;
    }

    .data-cards {
        grid-template-columns: 1fr;
    }

    .headerLeft {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .tab-switcher {
        margin-left: 0;
    }
}
</style>